import React, { Component } from 'react';
import { registerVendorNew, getCatDrop, emailExist, signUpApi, getLocation, verifyVendor, getCitiesByKeyWord } from '../../API/FetchCall';
import $ from 'jquery';
import FetchCall, { getPlan, CreatePay } from '../../API/FetchCall';
import Recaptcha from 'react-recaptcha';
import { MOBILE_REGEX, URL_REGEX, RAZORPAY_LIVE, RAZORPAY_TEST, GOOGLE_CAPTCHA_SITE_KEY } from '../../constant.js';
import SimpleReactValidator from 'simple-react-validator';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';
import { BASEURL } from '../../constant';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Autosuggest from 'react-autosuggest';
import TextField from '@material-ui/core/TextField';

import Geocode from "react-geocode";

Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();
class InstitutionalSignup extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fieldDisable: true,
      needmorecategory:false,
      btnDisable: false,
      signup_form: true,
      ins_first_next: false,
      confirmModal: false,
      organisation_name: '',
      user_type: '1',
      user_name: '',
      organisation_register_number: '',
      institution_contact_number: '',
      institution_email_address: '',
      email_id: '',
      phone_number: '',
      organisation_type: '',
      state: '',
      location: '',
      pin_code: '',
      address: '',
      cheque_image: '',
      org_type_list: [],
      social_media_link: '',
      is_org: false,
      is_owner: false,
      incharge_name: '',
      incharge_text: 'In-Charge ',
      social_link: '',
      socialPlace: 'LinkedIn',
      agree: '',
      cateList: [],
      autoSuggCate: [],
      state_name: '',
      ins_first_name: '',
      ins_last_name: '',
      owner_type: '',
      designation: '',
      email_address: '',
      phone_number: '',
      landline_number: '',
      ins_user_name: '',
      ins_password: '',
      ins_cpassword: '',
      package_list: [],
      agree: '',
      planinfo_option: true,
      category_List: [],
      categorySubTypeList: [],
      category_id: '',
      sub_category_id: '',
      agree_data: false,
      plan_price: 0,
      plan_price_original: 0,
      suggestions: [],
      currentData: [],
      location_list: [],
      updateProcess: false,
      isVerified: false,
      isEmailValid: true,
      isUserValid: true,
      main_id: '',
      main_type: '',
      showPassword: false,
      showCPassword: false,
      showOTPform:false,
      otp:'',
      userid:'',
      otpverified:false,
      mid:0,
      suggestionscities:[],
      rows: [{}],
      sub_cat_rows: [{}],
      categorySubTypeList_0:[],
      categorySubTypeList_1:[],
      categorySubTypeList_2:[],
      categorySubTypeList_3:[],
      categorySubTypeList_4:[],
      categorySubTypeList_5:[],
      categorySubTypeList_6:[],
      categorySubTypeList_7:[]
    }
    this.getLocation();
    this.orgList();
    this.cateList();
    this.categoryList();
    this.validator = new SimpleReactValidator({
      validators: {
        password_custome: {  // name the rule
          message: 'The :attribute must be a Min of 8 characters in length - One Capital Letter, One Number, One Character.',
          rule: (val, params, validator) => {
            return validator.helpers.testRegex(val, /^(?=.*\d)(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/) && params.indexOf(val) === -1
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        confirmpassword: {  // name the rule
          message: 'The :attribute must be Same as Password.',
          rule: (val, params, validator) => {
            if (val != this.state.ins_password) {
              return false;
            }
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        emailExist: {  // name the rule
          message: 'The :attribute Already Exist.',
          rule: (val, params, validator) => {
            return this.state.isEmailValid;
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        userExist: {  // name the rule
          message: 'The :attribute Already Exist.',
          rule: (val, params, validator) => {
            return this.state.isUserValid;
          },
          messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
          required: true  // optional
        },
        checkMobile: MOBILE_REGEX,
        checkUrl: URL_REGEX
      }
    });

    this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onSuggestionSelectedCity = this.onSuggestionSelectedCity.bind(this);
    this.handleChangeCat = this.handleChangeCat.bind(this);
    this.handleChangeMainCat = this.handleChangeMainCat.bind(this);

  }

  onChangeCity = (event, { newValue, method }) => {
    this.setState({
      location: newValue
    });
  
  };

 

  //suggestionscities
  shouldRenderSuggestionsCity = (value, reason) => {
    return value.trim().length > 2;
  };
  onSuggestionsFetchRequestedCity = ({ value }) => {
    const val = this.escapeRegexCharacters(value.trim());
    let fetch = JSON.stringify({
      keyword: val
    });
    getCitiesByKeyWord(fetch).then(res => {
      if (res.status == 1) {
        this.setState({
          suggestionscities: res.list
        });
      }
    });
  };

  onSuggestionSelectedCity = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method } ) => {
    
    //alert(suggestion.vendor_id);
    this.setState({
        state: suggestion.state
    });
  };

  onSuggestionsClearRequestedCity = () => {
    this.setState({
      suggestionscities: []
    });
  };
  
  getSuggestionValueCity = (suggestion) => {
  
    return suggestion.city;
  }

  renderSuggestionCity(suggestion) {
    return (
      <span>{suggestion.city}</span>
    );
  }
    

  async getLocation() {
    let req = JSON.stringify({
      url: 'getLocation'
    });
    getLocation(req).then(res => {
      if (res.status === 1) {
        this.setState({
          location_list: res.results
        });
      }
    })
  }
  async cateList() {
    getCatDrop(0).then((res) => {
      if (res.status === 1) {
        var list = res.results;
        list.map((item, i) => {
          item.options = item.options.flat(Infinity);
        })
        let fiArr = [];
        list.map((item, i) => {
          fiArr.push(item.options);
        })
        fiArr = fiArr.flat(Infinity);
        this.setState({
          cateList: res.results,
          autoSuggCate: fiArr,
        });
      }
    });


  }

  async categoryList() {
    let response = await FetchCall.getSubCategory('0');
    console.log('AgeList', response);
    if (response) {
      this.setState({ category_List: response.results });
    }else {
      this.setState({
        category_List: []
      })
    }
  }

  async Sub_Cat_type(id) {
    if (id) {
      let response = await FetchCall.getSubCategory(id);
      if (response.status == 1) {
        this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
      } else {
        this.setState({
          categorySubTypeList: []
        })
      }
    } else {
      this.setState({
        categorySubTypeList: []
      })
    }
  }


  async Sub_Cat_type_new(id, index) {

    if (id) {
      let response = await FetchCall.getSubCategory(id);
      if (response.status == 1) {
         if(index==0){
            this.setState({categorySubTypeList_0:response.results, cat_type: true, cat_type1: false, cat_type2: false });
          } 

          if(index==1){
            this.setState({categorySubTypeList_1:response.results, cat_type: true, cat_type1: false, cat_type2: false });
          } 

      }  
    }
  }
  

  getSelect = () => {

    let rows = '';
    {
      rows = this.state.cateList.length > 0 &&
        this.state.cateList.map((item, i) => {
          return (
            <option value={item.category_id} data-tokens={item.options.toString()}>{item.label}</option>
          )
        })
    }

    return rows;

  }
  showValidationErr(elm, msg) {
    this.setState((prevState) => ({ errors: [...prevState.errors, { elm, msg }] }));
  }
  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }
  componentDidMount() {
    this.getPlanList();

  }

  getPlanList = async () => {

    let insdata = JSON.stringify({
      user_type: 1,
    })
    try {
      getPlan(insdata).then((response) => {
        let list = response.results;
        let plan_info = list.filter(o => o.id == this.state.plan_id);
        console.log('plan_info', this.state.plan_id)
        if (plan_info.length > 0) {
          this.setState({
            package_list: response.results,
            base_price: plan_info[0]['base_price'],
            payable_price: plan_info[0]['plan_price'],
            discount_amount: plan_info[0]['discount_amount'],
            discount_percent: plan_info[0]['discount_percent'],
            plan_info: plan_info[0]['plan_offer'],
          });
        }
        this.setState({
          package_list: response.results,
        });
      });

    } catch (error) {
      this.setState({ error: true });
    }
  }
  handleShowPassword() {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  }
  handleShowCPassword() {
    this.setState((prevState) => ({
      showCPassword: !prevState.showCPassword,
    }));
  }
  async orgList() {
    let response = await FetchCall.getSubCategory('0');
    console.log('boeList', response);
    if (response) {
      this.setState({ org_type_list: response.results });
    }
  }
  validateMail(value, type) {
    let name = (type == 1) ? 'email_id' : 'user_name';
    let type_name = (type == 1) ? 'isEmailValid' : 'isUserValid';
    let req = JSON.stringify({
      [name]: value
    });
    let res = emailExist(req).then(res => {
      if (res.status === 1) {
        this.setState({
          [type_name]: false
        });
      } else {
        // return res.status;
        this.setState({
          [type_name]: true
        });
      }
    });
  }
  toggleChange = () => {
    this.setState({
      agree_data: !this.state.agree_data,
    });
  }
  handleChange = (e) => {
    const propName = e.target.name;
    this.setState({ [e.target.name]: e.target.value });
    if (propName == 'institution_email_address') {
      this.setState({ email_address: e.target.value });
      this.validateMail(e.target.value, 1);
    }
    if (propName == 'email_address') {
      this.validateMail(e.target.value, 1);
    }
    if (propName == 'ins_user_name') {
      this.validateMail(e.target.value, 2);
    }

  };


  handleSelect = (e) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: value });
    if (propName === 'social_link' && value[0] === 'fb') {
      this.setState({
        socialPlace: 'Facebook'
      })
    } else if (propName === 'social_link' && value[0] === 'twt') {
      this.setState({
        socialPlace: 'Twitter'
      })
    } else if (propName === 'social_link' && value[0] === 'lnkin') {
      this.setState({
        socialPlace: 'LinkedIn'
      })
    } else if (propName === 'social_link' && value[0] === 'insta') {
      this.setState({
        socialPlace: 'Instagram'
      })
    }

    if (propName === 'category_id') {
      let categoryid = e.target.value;
      this.Sub_Cat_type(categoryid);
    }

    if(propName==='sub_category_id'){
        this.setState({needmorecategory:true});
    }


  };
  handleplaceChangeIns = address => {
    this.setState({ address, pin_code: '', state: '', location: '' });
  };

  handleplaceChangeInd = ind_address => {
    this.setState({ ind_address, ind_pin_code: '', ind_state_name: '', ind_location: '' });
  };

  handleplaceSelectIns = address => {
    this.setState({ address: address });
    Geocode.fromAddress(address).then(
      response => {

        var geolen = response.results[0].address_components.length;
        var pincode = '';
        var state = '';
        var city = '';
        for (let i = 0; i < geolen; i++) {

          if (response.results[0].address_components[i].types[0] == "postal_code") {
            pincode = response.results[0].address_components[i].short_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
            state = response.results[0].address_components[i].long_name;
          }
          if (response.results[0].address_components[i].types[0] == "locality") {
            //city = response.results[0].address_components[i].long_name;
          }

        }


        this.get_location(pincode, state, city);
      },
      error => {
        console.error(error);
      }
    );
  };

  handleplaceSelectInd = ind_address => {
    this.setState({ ind_address: ind_address });
    Geocode.fromAddress(ind_address).then(
      response => {

        var geolen = response.results[0].address_components.length;
        var pincode = '';
        var state = '';
        var city = '';
        for (let i = 0; i < geolen; i++) {

          if (response.results[0].address_components[i].types[0] == "postal_code") {
            pincode = response.results[0].address_components[i].short_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
            state = response.results[0].address_components[i].long_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
            //city = response.results[0].address_components[i].long_name;
          }

        }


        this.get_ind_location(pincode, state, city);
      },
      error => {
        console.error(error);
      }
    );
  };


  Geocode_location() {
    Geocode.fromAddress(this.state.address).then(
      response => {

        var geolen = response.results[0].address_components.length;
        var pincode = '';
        var state = '';
        var city = '';
        for (let i = 0; i < geolen; i++) {

          if (response.results[0].address_components[i].types[0] == "postal_code") {
            pincode = response.results[0].address_components[i].short_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
            state = response.results[0].address_components[i].long_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
            city = response.results[0].address_components[i].long_name;
          }

        }


        this.get_location(pincode, state, city);
      },
      error => {
        console.error(error);
      }
    );

  }


  get_location(pincode, state, city) {
    console.log(pincode, state, city);
    this.setState({
      pin_code: pincode,
      state: state,
      location: city,
    });
  }
  get_ind_location(pincode, state, city) {
    console.log(pincode, state, city);
    this.setState({
      ind_pin_code: pincode,
      ind_state_name: state,
      ind_location: city,
    });
  }
  handleFile = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] });
  };

  getRender = (params) => {

    return (<TextField
      {...params}
      variant="outlined"
      placeholder="Type Category Here"
    />);
  }
  onTagsChange = (event, values) => {

    let list = this.state.cateList;
    list.map((item, i) => {
      item.options = item.options.flat(Infinity);
    });
    var finalArr = [];
    list.map((item, i) => {
      let intersection = item.options.filter(x => values.includes(x));
      if (intersection.length > 0) {
        finalArr.push(item.category_id)
      }
    });

    this.setState({
      organisation_type: finalArr,
      sub_category: values,
    })

  }
  handleInsFirstNext = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({
        ins_first_next: true,
        signup_form: false,
      });

    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }

  }

  handleInsFirstPre = (e) => {
    e.preventDefault();
    this.setState({
      ins_first_next: false,
      signup_form: true,
    });
  }

  handleInsSecondPre = (e) => {
    e.preventDefault();
    this.setState({
      ins_first_next: true,
      ins_second_next: false,
    });
  }


  recaptchaLoaded = (e) => {
    console.log('Successfully loaded');
  }
  verifyCallback = (response) => {
    if (response) {
      this.setState({
        isVerified: true,
      });
    }

  }

  handleVerifyUser = (e) => {

      let ins = '';

      ins = JSON.stringify({
        user_id: this.state.userid,
        otp:this.state.otp
      });

      verifyVendor(ins).then((res) => {

        if (res.status === 1) {
           
          this.setState({otpverified:true})

        }


      });

  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({
        btnDisable: true
      });
      let ins = '';
      let rowsCount = this.state.rows.length;

      ins = JSON.stringify({
        maincatRows:this.state.rows,
        subcatRows:this.state.sub_cat_rows,
        rowsCount:rowsCount,
        mid:this.state.mid,
        user_type: this.state.user_type,
        organisation_name: this.state.organisation_name,
        organisation_register_number: this.state.organisation_register_number,
        address: this.state.address,
        pin_code: this.state.pin_code,
        state: this.state.state,
        location: this.state.location,
        institution_contact_number: this.state.institution_contact_number,
        institution_email_address: this.state.institution_email_address,
        social_link: this.state.social_link,
        social_media_link: this.state.social_media_link,
        category_id: this.state.category_id,
        first_name: this.state.ins_first_name,
        last_name: this.state.ins_last_name,
        owner_type: this.state.owner_type,
        designation: this.state.designation,
        email_id: this.state.email_address,
        phone_number: this.state.phone_number,
        landline_number: this.state.landline_number,
        user_name: this.state.ins_user_name,
        password: this.state.ins_password,
        cpassword: this.state.ins_cpassword,
        plan_id: 0,
        agree: this.state.agree,
        agree_data:this.state.agree_data,
        sub_category: this.state.sub_category_id,
        user_paytype: 2,
        main_id: this.state.main_id,
        main_type: this.state.main_type,
        main_category_id: this.state.category_id,
      });

      console.log('ins',ins)
      //return false;

      registerVendorNew(ins).then((res) => {
        let toastr = '';
        if (res.status === 1) {
          /*
          toastr = window.toastr.success;
          toastr('', 'Your Activation link  has been sent your to registered email id please click the link to activate your account.', {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
          */
          this.setState({
            showOTPform: true,
            userid:res.userid
          });
          /*
          setTimeout(function () {
            window.location.replace('/login');
          }, 2000);
          */
        } else {

          if (res.status === 3) {
              alert("Error:" + res.message);
          }else{
          let er = res.errors[0].msg
          /*
          toastr = window.toastr.error; //warning
          toastr(er, toastr, {
            positionClass: "toast-bottom-right",
            containerId: "toast-bottom-right"
          });
          */
          alert("Error:" + er);
          
          this.setState({
            btnDisable: false
          });
          }
        }
      });

    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }


  }
  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  shouldRenderSuggestions = (value, reason) => {
    return value.trim().length > 2;
  };
  onSuggestionsFetchRequested = ({ value }) => {
    const val = this.escapeRegexCharacters(value.trim());
    let fetch = JSON.stringify({
      keyword: val,
      url: 'getDataByName'
    });
    signUpApi(fetch).then(res => {
      if (res.status == 1) {
        this.setState({
          suggestions: res.result
        });
      }
    });
  };


  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method } ) => {
    
    //alert(suggestion.vendor_id);
    this.setState({
        mid: suggestion.id
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  
  getSuggestionValue = (suggestion) => {
    this.setState({ confirmModal: true });
    let currentData = suggestion;
    currentData.url = 'getDataById';
    let data = JSON.stringify(currentData);
    signUpApi(data).then(res => {
      if (res.status === 1) {
        let data = res.result;
        const rows = this.state.rows;
        rows[0].category_id =  data.main_category;
        this.setState({
          organisation_register_number: data.registration_no,
          address: data.address,
          location: data.location,
          state: data.state,
          pin_code: data.pincode,
          institution_contact_number: data.phone_number,
          institution_email_address: data.email_id,
          updateProcess: true,
          main_id: data.id,
          main_type: suggestion.type,
          sub_category_id: suggestion.sub_link.split(',')
        });
        this.Sub_Cat_type_new(data.main_category,0);
      } else {
        this.setState({
          organisation_register_number: '',
          address: '',
          location: '',
          state: '',
          pin_code: '',
          institution_contact_number: '',
          institution_email_address: '',
          category_id: '',
          updateProcess: false,
          main_id: '',
          main_type: '',
          sub_category_id: ''
        });
      }
    });
    return suggestion.name;
  }

  renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }

  onChange = (event, { newValue, method }) => {
    this.setState({
      organisation_name: newValue
    });
    if (newValue.length > 2) {
      this.setState({
        fieldDisable: false
      })
    } else {
      this.setState({
        fieldDisable: true
      })
    }
  };
  cancelPop = () => {
    this.setState({
      confirmModal: false,
      currentData: [],
      organisation_register_number: '',
      address: '',
      location: '',
      state: '',
      pin_code: '',
      institution_contact_number: '',
      institution_email_address: '',
      category_id: '',
      updateProcess: false,
      main_id: '',
      main_type: '',
      sub_category_id: ''
    })
  }
  getsuggestData = () => {
    this.setState({
      confirmModal: false,
    });
  }

  handleChangeMainCat = idx => e => {

    
    const { name, value } = e.target;
    const rows = [...this.state.rows];
   
    const previousValue = rows[idx].category_id; 
    console.log("value",previousValue);

    if(previousValue==value){
      alert("Already you have selected as primary category!");
      return false;
    }
    else{

      rows[idx] = {
        [name]: value
      };
      this.setState({
        rows
      });

      this.Sub_Cat_type_new(value, idx);

    }
   

  };

  handleChangeCat = idx => e => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    const sub_cat_rows = [...this.state.sub_cat_rows];
    sub_cat_rows[idx] = {
      [propName]: value
    };
    this.setState({
      sub_cat_rows
    });
  };

  handleAddRow = () => {
    const item = {
      category_id: "",
      sub_category_id: ""
    };
    this.setState({
      rows: [...this.state.rows, item]
    });
  };
  handleRemoveRow = () => {
    this.setState({
      rows: this.state.rows.slice(0, -1)
    });
  };
  handleRemoveSpecificRow = (idx) => () => {
    const rows = [...this.state.rows]
    rows.splice(idx, 1)
    this.setState({ rows })
  }

  render() {

    const inputPropscity = {
      placeholder: "Type City",
      value: this.state.location,
      onChange: this.onChangeCity,
      name: 'location',
      className: 'form-control'
    };
    

    
    const { value, suggestions, suggestionscities } = this.state;
    this.validator.purgeFields();
    var plans = this.state.plan_info ? this.state.plan_info.split('\\') : [];
    plans = plans.filter(function (el) {
      return el != null && el != '';
    });
    const inputProps = {
      placeholder: "Name of the Institution",
      value: this.state.organisation_name,
      onChange: this.onChange,
      name: 'organisation_name',
      className: 'form-control'
    };
    this.validator.purgeFields();
    return (
      <div className="container-fluid">
        <form onSubmit={this.handleSubmit}>
          <Modal isOpen={this.state.confirmModal} className='modal-sm custome-modal' style={{ top: "20%" }}>
            <ModalBody className='p-0'>
              <div className='row'>
                <div className='col-md-12'>
                  <h4 className="text-center">Is this your institution?</h4>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <div className='row'>
                <div className='col-md-12 text-center'>
                  <button className='btn btn-sm btn-default' onClick={this.cancelPop}>No</button>
                  <button className='btn btn-sm btn-cus-blue' onClick={this.getsuggestData}>Yes</button>
                </div>
              </div>

            </ModalFooter>
          </Modal>
          <div className="row">
            <div className="col-md-6 col-sm-6 sign-bg-login   hidden-xs">
              <div className="shadow-bg"></div>
              <h1>
                Welcome to
                <br /> BeWise Partner Program
              </h1>
            </div>
            <div className="col-md-6 col-sm-6 signup-right">
              <div className="inner-right">
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="right-logo">
                      <a href='/institution'>
                        <img src="assets/images/bewiselogo.png" />
                      </a>
                    </div>
          

                     {(this.state.signup_form === false && this.state.showOTPform===true) ?
                      <div>
                        <h1>Verification</h1>


                        {this.state.otpverified && 

                      <div class="aftervrying alert alert-success">
                          
                            Thank you for registering with us and your account has been verified successfully. Please click <a href="/login">here</a> to login and become bewise partner

                      </div>
                      }

                      {!this.state.otpverified &&
                        <div>
                        <div class="smalltext">We have sent you an OTP to your registering email id successfully</div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                               <label>OTP<span className="astrick">(you may have received in your inbox or junk or spam)</span></label>

                               <div className="custom-select-drop dropdown">
                                <input type="text" name="otp"
                                  value={this.state.otp}
                                  placeholder="OTP"
                                  onChange={this.handleChange}
                                  className="form-control"  />
                                {this.validator.message('Verification OTP', this.state.otp, 'required', { className: 'text-danger' })}
                              </div>

                            </div>
                          </div>

                          <div className="col-md-12 col-sm-12 text-right">
                            <button type='button' className="btn orange-btn" onClick={this.handleVerifyUser}>Verify</button>
                          </div>
                         
                        </div>
                        </div>
                        }

                      </div>

                      : ''}


                    {(this.state.signup_form === true && this.state.showOTPform===false) ?
                      <div>
                        <h1>Institution Details</h1>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Name of the Institution  <i class="fa fa-info-circle" data-toggle="tooltip" title='Enter institution name only if not in our list' aria-hidden="true"></i> <span className="astrick">*</span></label>
                              <Autosuggest
                                suggestions={suggestions}
                                shouldRenderSuggestions={this.shouldRenderSuggestions}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                getSuggestionValue={this.getSuggestionValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={inputProps} />
                              {this.validator.message('Name of the Institution', this.state.organisation_name, 'required', { className: 'text-danger' })}
                            </div>

                          </div>
                          {/* <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Business Registration Number<span className="astrick">*</span></label>
                              <input type="text" name="organisation_register_number" id="organisation_register_number"
                                placeholder="Business Registration Number"
                                disabled={this.state.fieldDisable}
                                value={this.state.organisation_register_number}
                                onChange={this.handleChange} className="form-control" />
                              {this.validator.message('Business Registration Number', this.state.organisation_register_number, 'alpha_num', { className: 'text-danger' })}
                            </div>
                          </div> */}
                        </div>
                        <div className="row">
                          <div className="col-md-12 col-sm-12">
                            <div className="form-group">
                              <label>Address of the Institution<span className="astrick">*</span></label>
                              <PlacesAutocomplete
                                value={this.state.address}
                                className="form-control"
                                onChange={this.handleplaceChangeIns}
                                onSelect={this.handleplaceSelectIns}
                              >
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                  <div >
                                    <input
                                      {...getInputProps({
                                        placeholder: 'Search Places ...',
                                        className: 'form-control',
                                        id: 'address_ins',
                                        disabled: this.state.fieldDisable,
                                      })}
                                      value={this.state.address}
                                    />
                                    <div className="autocomplete-dropdown-container"
                                      style={{ position: "absolute", zIndex: "999" }}>
                                      {loading && <div>Loading...</div>}
                                      {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                          ? 'suggestion-item--active'
                                          : 'suggestion-item';
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                          ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                          : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                        return (
                                          <div
                                            {...getSuggestionItemProps(suggestion, {
                                              className,
                                              style,
                                            })}
                                          >
                                            <span>{suggestion.description}</span>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </PlacesAutocomplete>
                              {this.validator.message('Address of the Institution', this.state.address, 'required', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>City<span class="astrick"> * Please choose from the list </span></label>
                              <div className="custom-select-drop dropdown">
                                {/* <input type="text" name="location"
                                  value={this.state.location}
                                  placeholder="City"
                                  onChange={this.handleChange}
                                  className="form-control" id="city_ins" disabled={this.state.fieldDisable} /> */}

                                  <Autosuggest
                                suggestions={suggestionscities}
                                shouldRenderSuggestions={this.shouldRenderSuggestionsCity}
                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedCity}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequestedCity}
                                getSuggestionValue={this.getSuggestionValueCity}
                                renderSuggestion={this.renderSuggestionCity}
                                onSuggestionSelected={this.onSuggestionSelectedCity}
                                inputProps={inputPropscity} />

                                
                                {this.validator.message('City', this.state.location, 'required|alpha_space', { className: 'text-danger' })}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>State<span class="astrick">*</span></label>
                              <div className="custom-select-drop dropdown">
                                <input type="text" name="state"
                                  value={this.state.state}
                                  placeholder="State"
                                  onChange={this.handleChange}
                                  className="form-control" id="state_ins" disabled={this.state.fieldDisable} />
                                {this.validator.message('State', this.state.state, 'required|alpha_space', { className: 'text-danger' })}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Pincode<span class="astrick">*</span></label>
                              <input type="number" name="pin_code"
                                placeholder="Pincode"
                                className="form-control"
                                id="pincode_ins"
                                value={this.state.pin_code}
                                onChange={this.handleChange}
                                disabled={this.state.fieldDisable}
                              />
                              {this.validator.message('Pincode', this.state.pin_code, 'required|numeric|min:1,num', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          {/* <div className="col-lg-6 col-md-12"></div> */}
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Institution Contact Number<span class="astrick">*</span></label>
                              {/* <div className="phone-wrapper">
                                <div className="custom-select-drop dropdown">
                                  <select className="form-control selectpicker" id="contact_ins" disabled={this.state.fieldDisable}>
                                    <option>+91</option>
                                  </select>
                                </div> */}
                              <input type="number" className="form-control"
                                name="institution_contact_number"
                                id="institution_contact_number"
                                value={this.state.institution_contact_number}
                                onChange={this.handleChange}
                                placeholder="Institution Contact Number" disabled={this.state.fieldDisable}
                              />
                              {/* </div> */}

                              {this.validator.message('Institution Contact Number', this.state.institution_contact_number, 'required|checkMobile|min:10|max:15', { className: 'text-danger' })}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Institution Email Address<span class="astrick">*</span></label>
                              <input type="text" className="form-control"
                                name="institution_email_address"
                                id="institution_email_address"
                                value={this.state.institution_email_address}
                                onChange={this.handleChange}
                                placeholder="Institution Email Address" disabled={this.state.fieldDisable}
                              />
                              {this.validator.message('Institution Email Address', this.state.institution_email_address, 'required|email', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        {/* <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Select social media<span class="astrick">*</span></label>
                              <div className="custom-select-drop dropdown">
                                <select className="form-control select-dropdown w-100"
                                  title="Select"
                                  name="social_link"
                                  id="social_link"
                                  onChange={this.handleSelect}
                                  value={this.state.social_link} disabled={this.state.fieldDisable}>
                                  <option value=''>Select</option>
                                  <option value='lnkin'>LinkedIn </option>
                                  <option value='fb'>Facebook </option>
                                  <option value='insta'>Instagram </option>
                                  <option value='twt'>Twitter </option>
                                </select>
                                {/* {this.validator.message('social media', this.state.social_link, 'required', { className: 'text-danger' })} 
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Social media link or page name  <i class="fa fa-info-circle" data-toggle="tooltip" title='Please copy paste url from your social media home page' aria-hidden="true"></i> <span class="astrick">*</span></label>
                              <input id="social_media_link" type="text" name="social_media_link"
                                value={this.state.social_media_link}
                                onChange={this.handleChange}
                                className="form-control"
                                placeholder={this.state.socialPlace} disabled={this.state.fieldDisable} />
                              {this.validator.message('Social media link must start with `https://...` and it', this.state.social_media_link, 'url', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div> */}
                        
                        <div className="row clearfix">
            <div className="col-md-12 column"> 
                        <table
                className="table table-bordered table-hover table-sm"
                id="tab_logic"
              >
                <thead>
                  <tr>
                    <th className="text-center"> # </th>
                    <th className="text-center"> Type </th>
                    <th className="text-center"> Category </th>
                    <th className="text-center"> Subcategory </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {this.state.rows.map((item, idx) => (
                    <tr id="addr0" key={idx}>
                      <td>{idx+1}</td>
                      <td>{idx==0? "Primary": "Secondary"}</td>
                      <td>
                      <select
                        onChange={this.handleChangeMainCat(idx)}
                        name={"category_id"}
                        id={"category_id"}
                        value={this.state.rows[idx].category_id}
                        className='form-control' title='Select Category' disabled={this.state.fieldDisable}>
                        <option value=''>Select</option>
                        {this.state.category_List.length > 0 &&
                          this.state.category_List.map((item, i) => {
                            return (
                              <option value={item.category_id} >
                                {item.category_name}
                              </option>
                            )
                          })}
                      </select>
                      </td>
                      <td>
                        {(idx==0) &&
                      <select
                        onChange={this.handleChangeCat(idx)}
                        name={"sub_category_id"}
                        multiple
                        id={"sub_category_id"}
                        value={this.state.rows[idx].sub_category_id}
                        className='form-control selectpicker' title='Select' disabled={this.state.fieldDisable} >
                        {this.state.categorySubTypeList_0.length > 0 &&
                          this.state.categorySubTypeList_0.map((item, i) => {
                            return (
                              <option value={item.category_id} >
                                {item.category_name}
                              </option>
                            )
                          })}
                      </select>
                          }

                      {(idx==1) &&
                      <select
                        onChange={this.handleChangeCat(idx)}
                        name={"sub_category_id"}
                        id={"sub_category_id"}
                        multiple
                        value={this.state.rows[idx].sub_category_id}
                        className='form-control selectpicker' title='Select' disabled={this.state.fieldDisable} >
                        {this.state.categorySubTypeList_1.length > 0 &&
                          this.state.categorySubTypeList_1.map((item, i) => {
                            return (
                              <option value={item.category_id} >
                                {item.category_name}
                              </option>
                            )
                          })}
                      </select>
                          }
                      </td>
                      <td>
                        {idx>0 &&
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={this.handleRemoveSpecificRow(idx)}
                        >
                          Remove
                        </button>
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {this.state.rows.length<2 &&
              <button onClick={this.handleAddRow} className="btn btn-primary btn-sm">
                Add More Category
              </button>
              }
            </div>
          </div>


                        <div className="col-md-12 col-sm-12 text-right">
                          <button type='submit' className="btn orange-btn" onClick={this.handleInsFirstNext}>NEXT</button>
                        </div>
                      </div> : ''}
                    {(this.state.ins_first_next === true && this.state.showOTPform===false) ?
                      <div>
                        <h1>Contact  Details</h1>
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Your Name <i class="fa fa-info-circle" data-toggle="tooltip" title='Pease make sure only alphabets(no space)' aria-hidden="true"></i> <span class="astrick">*</span></label>
                              <input
                                type="text"
                                placeholder="Name"
                                name="ins_first_name"
                                value={this.state.ins_first_name}
                                onChange={this.handleChange}
                                className="form-control"
                              />
                              {this.validator.message('Name', this.state.ins_first_name, 'required', { className: 'text-danger' })}
                            </div>
                          </div>
                          {/* <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Last Name <i class="fa fa-info-circle" data-toggle="tooltip" title='Pease make sure only alphabets(no space)' aria-hidden="true"></i> <span class="astrick">*</span></label>
                              <input type="text"
                                className="form-control"
                                name="ins_last_name"
                                value={this.state.ins_last_name}
                                onChange={this.handleChange}
                                placeholder="Last Name"
                              />
                              {this.validator.message('Last Name', this.state.ins_last_name, 'required|alpha', { className: 'text-danger' })}
                            </div>
                          </div> */}
                        </div>

                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Are you the owner?<span class="astrick">*</span></label><br />
                              <input type="radio" name="owner_type" checked={this.state.owner_type === '1'}
                                value='1' onChange={this.handleChange} /> Yes&nbsp;&nbsp;
                              <input type="radio" name="owner_type" checked={this.state.owner_type === '2'}
                                value='2' onChange={this.handleChange} /> No &nbsp;&nbsp;&nbsp;
                            </div>
                            {this.validator.message('owner', this.state.owner_type, 'required', { className: 'text-danger' })}
                          </div>
                        </div>

                        <div className="row">
                          {this.state.owner_type == 2 && (
                            <div className="col-md-6 col-sm-6">
                              <div className="form-group">
                                <label>Designation</label>
                                <input
                                  type="text"
                                  placeholder="Designation"
                                  className="form-control"
                                  name="designation"
                                  value={this.state.designation}
                                  onChange={this.handleChange}
                                />
                                {this.validator.message('Designation', this.state.designation, 'required|alpha_space', { className: 'text-danger' })}
                              </div>
                            </div>
                          )}

                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Your Login Id<span class="astrick">*</span></label>
                              <input type="text"
                                placeholder="Email Address"
                                name="email_address"
                                value={this.state.email_address}
                                onChange={this.handleChange}
                                className="form-control" />
                              {this.validator.message('Email Address', this.state.email_address, 'required|emailExist|email', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Mobile Number<span class="astrick">*</span></label>
                              {/* <div className="phone-wrapper">
                                <div className="custom-select-drop dropdown">
                                  <select className="form-control selectpicker" disabled={this.state.fieldDisable}>
                                    <option>+91</option>
                                  </select>
                                </div> */}
                              <input type="number" name="phone_number"
                                value={this.state.phone_number}
                                placeholder="Mobile Number"
                                onChange={this.handleChange} className="form-control" />
                              {/* </div> */}
                              {this.validator.message('Mobile Number', this.state.phone_number, 'required|checkMobile|min:10|max:60', { className: 'text-danger' })}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Landline Number</label>
                              {/* <div className="phone-wrapper">
                                <div className="custom-select-drop dropdown">
                                  <select className="form-control selectpicker">
                                    <option>+91</option>
                                  </select>
                                </div> */}
                              <input type="number" name="landline_number"
                                value={this.state.landline_number}
                                placeholder="Landline Number"
                                onChange={this.handleChange} className="form-control" />
                              {/* </div> */}
                              {this.validator.message('Landline Number', this.state.landline_number, 'numeric', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 col-sm-12">
                            <h1>BeWise Portal Login Details</h1>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Your User Name<span class="astrick">*</span></label>
                              <input type="text" name="ins_user_name" value={this.state.ins_user_name}
                                placeholder="User Name"
                                onChange={this.handleChange} className="form-control" />
                              {this.validator.message('User Name', this.state.ins_user_name, 'required|alpha_num|userExist', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Your Password<span class="astrick">*</span></label>
                              <input id="password-field" type={this.state.showPassword ? 'text' : 'password'}
                                name="ins_password"
                                value={this.state.ins_password}
                                placeholder="Password"
                                onChange={this.handleChange}
                                className="form-control" />
                              <span
                                toggle='#password-field'
                                className={this.state.showPassword ? 'fa fa-fw fa-eye-slash field-icon' : 'fa fa-fw fa-eye field-icon'}
                                onClick={() => {
                                  this.handleShowPassword();
                                }}
                              ></span>
                              {this.validator.message('Password', this.state.ins_password, 'required|password_custome', { className: 'text-danger' })}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-6">
                            <div className="form-group">
                              <label>Confirm Password<span class="astrick">*</span></label>
                              <input id="password-fieldc" type={this.state.showCPassword ? 'text' : 'password'}
                                name="ins_cpassword"
                                placeholder="Confirm Password"
                                value={this.state.ins_cpassword}
                                onChange={this.handleChange}
                                className="form-control" />
                              <span
                                toggle='#password-field'
                                className={this.state.showCPassword ? 'fa fa-fw fa-eye-slash field-icon' : 'fa fa-fw fa-eye field-icon'}
                                onClick={() => {
                                  this.handleShowCPassword();
                                }}
                              ></span>
                              {this.validator.message('Confirm Password', this.state.ins_cpassword, 'required|confirmpassword', { className: 'text-danger' })}
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12 col-sm-12">
                          <label className="custom-checkboxs" style={{ marginTop: "10px" }}>
                            <label>
                              <input type="checkbox" className="" name="agree"
                                value="Yes" onChange={this.toggleChange} checked={this.state.agree_data} />&nbsp;&nbsp;
                              I Agree to &nbsp;
                              <span style={{ color: "#1492E6" }}>
                                {/* <a href={BASEURL + "termsconditions"} target="_blank"> */}
                                <a href="javascript:window.open('/privacypolicy', 'privacypolicy', 'width=auto,height=auto')" target="_blank">
                                  Terms of service </a>
                                and &nbsp;
                                {/* <a href={BASEURL + "privacypolicy"} target="_blank"> */}
                                <a href="javascript:window.open('/privacypolicy', 'privacypolicy', 'width=auto,height=auto')" target="_blank">
                                  Privacy policy
                                </a>
                                <span class="astrick">*</span>
                              </span>
                            </label>

                          </label>
                          {this.validator.message('Agree', this.state.agree_data, 'accepted', { className: 'text-danger' })}
                        </div>
                        <div className="col-md-12 col-sm-12">
                          <label className="custom-checkboxs" style={{ marginTop: "10px" }}>
                            <Recaptcha
                              sitekey={GOOGLE_CAPTCHA_SITE_KEY}
                              render="explicit"
                              onloadCallback={this.recaptchaLoaded}
                              verifyCallback={this.verifyCallback}
                            />
                          </label>
                          {this.validator.message('Google reCaptcha', this.state.isVerified, 'accepted', { className: 'text-danger' })}
                        </div>
                        <div className="row">
                          <div className="col-md-6 col-sm-6">
                            <button type='submit' className="btn orange-btn"
                              onClick={this.handleInsFirstPre}
                            >BACK</button>
                          </div>
                          <div className="col-md-6 col-sm-6 text-right">
                            <button type='submit' className="btn orange-btn"
                              disabled={this.state.btnDisable}
                            >{this.state.btnDisable ? 'Please Wait...' : 'Submit'}</button>
                          </div>
                        </div>
                      </div> : ''}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div >

    )
  }
}

export default InstitutionalSignup;


// WEBPACK FOOTER //
// ./src/components/SignUp/institutional_signup.jsx